import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import './movie.css';

import api from '../../services/api';

export default function Movie() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [movie, setMovie] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadFilme() {
      await api
        .get(`/movie/${id}`, {
          params: {
            api_key: '1ad71e78a610f1217e0b68dad3f1fa85',
            language: 'pt-BR',
            page: 1,
          },
        })
        .then((response) => {
          // console.log(response.data);
          setMovie(response.data);
          setLoading(false);
        })
        .catch(() => {
          // console.log('Filme não encontrado');
          navigate('/', { replace: true });
          return;
        });
    }

    loadFilme();

    return () => {
      // console.log('Componente foi desmontado');
    };
  }, [navigate, id]);

  function saveMovie() {
    // alert('OK');
    const minhaLista = localStorage.getItem('@primeflix');

    let filmesSalvos = JSON.parse(minhaLista) || [];

    const hasFilme = filmesSalvos.some((filmesSalvos) => filmesSalvos.id === movie.id);

    if (hasFilme) {
      // alert('Esse filme já está na lista');
      toast.warn('Esse filme já está na sua lista!')
      return;
    }

    filmesSalvos.push(movie);
    localStorage.setItem('@primeflix', JSON.stringify(filmesSalvos));
    // alert('Filme salvo com sucesso');
    toast.success('Filme salvo com sucesso!');
  }

  if (loading) {
    return (
      <div className="filme-info">
        <h1>Carregando detalhes...</h1>
      </div>
    );
  }

  return (
    <div className="filme-info">
      <h1>{movie.title}</h1>
      <img
        src={`https://image.tmdb.org/t/p/original/${movie.backdrop_path}`}
        alt={movie.title}
      />
      <h3>Sinopse</h3>
      <span>{movie.overview}</span>
      <strong>Avaliação: {movie.vote_average} / 10</strong>

      <div className="area-buttons">
        <button onClick={saveMovie}>Salvar</button>
        <button>
          <a
            target="blank"
            rel="external"
            href={`https://youtube.com/results?search_query=${movie.title} trailer`}
          >
            Trailer
          </a>
        </button>
      </div>
    </div>
  );
}
